import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSidePanelComponent from './adpSidePanel.component';

let adpSidePanelModule = angular.module('adpSidePanel', [
  uiRouter
])

.component('adpSidePanel', adpSidePanelComponent)

.name;

export default adpSidePanelModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSidePanel/adpSidePanel.js